import {
  ApprovalsV2ValueObjectsApprovalProcessDecisionEnum,
  ApprovalsV2ValueObjectsReviewRequestDecisionEnum,
  ProcurementValueObjectsPurchaseRequestStatusEnum,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface ApprovalProcess {
  decision?: ApprovalsV2ValueObjectsApprovalProcessDecisionEnum | null
  reviewRequests?: Array<{
    decision?: ApprovalsV2ValueObjectsReviewRequestDecisionEnum | null
  }> | null
}

interface GetApprovalProcessStatusParams {
  status: ProcurementValueObjectsPurchaseRequestStatusEnum
  approvalProcess?: ApprovalProcess | null
}

export const getApprovalProcessStatus = ({
  status,
  approvalProcess,
}: GetApprovalProcessStatusParams): ProcurementValueObjectsPurchaseRequestStatusEnum => {
  if (approvalProcess?.decision) {
    return approvalProcess.decision
  }

  if (approvalProcess?.reviewRequests?.some((rr) => rr.decision === 'changes_requested')) {
    return 'changes_requested'
  }

  return status
}

export type PurchaseRequestStatusType = 'positive' | 'warning' | 'critical'

export const getPurchaseRequestStatusLabel = (
  status: ProcurementValueObjectsPurchaseRequestStatusEnum
): { type: PurchaseRequestStatusType; label: string } => {
  const statusInfo: Record<
    ProcurementValueObjectsPurchaseRequestStatusEnum,
    { type: PurchaseRequestStatusType; label: string }
  > = {
    ['approved']: {
      type: 'positive',
      label: i18n.t('procurement.purchase_requests.status.approved'),
    },
    ['draft']: {
      type: 'warning',
      label: i18n.t('procurement.purchase_requests.status.draft'),
    },
    ['pending']: {
      type: 'warning',
      label: i18n.t('procurement.purchase_requests.status.pending'),
    },
    ['changes_requested']: {
      type: 'warning',
      label: i18n.t('procurement.purchase_requests.status.changes_requested'),
    },
    ['rejected']: {
      type: 'critical',
      label: i18n.t('procurement.purchase_requests.status.rejected'),
    },
  }

  return statusInfo[status]
}
